import React from 'react';

import { ThemeProvider } from '@emotion/react';

import {
    atcTheme,
    fordTheme,
    kbbTheme,
} from '@argo/themes';

export default ({ brand = 'atc', ...props }) => (
    <ThemeProvider
        theme={{
            ford: fordTheme,
            kbb: kbbTheme,
        }[brand] ?? atcTheme}
        {...props}
    />
);
